import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import "./gradient-button.scss";

/**
 * GradientButton — A reusable animated gradient pill button component
 * Features a flowing gradient animation with hover effects
 *
 * @param {string} text - Button text
 * @param {function} onClick - Click handler
 * @param {boolean} loading - Shows a spinner and disables interaction
 * @param {"medium"|"small"} size - Size variant; "medium" is default
 * @param {object} sx - Additional MUI sx props
 */
const GradientButton = ({ text, onClick, loading = false, size = "medium", sx = {} }) => {
  const sizeClass = size === "small" ? " gradient-button--small" : "";
  return (
    <Box
      className={`gradient-button${sizeClass}${loading ? " gradient-button--loading" : ""}`}
      onClick={!loading ? onClick : undefined}
      sx={sx}
    >
      {loading ? (
        <CircularProgress size={size === "small" ? 16 : 20} sx={{ color: "#fff" }} />
      ) : (
        <Typography
          variant={size === "small" ? "body2" : "body1"}
          sx={{ color: "#fff", fontWeight: 600, margin: 0 }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default GradientButton;
